import { format, parse, sub } from 'date-fns';

export const DATE_FORMAT = 'dd.MM.yyyy';
export const MONTH_YEAR_FORMAT = 'MM.yyyy';
export const TIME_FORMAT = 'HH:mm';
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
export const ISO_DATE_FORMAT = 'yyyy-MM-dd';
export const EARLIEST_INVOICES_YEAR = 2019;

export function now(): Date {
  return new Date();
}

export function formatDate(date: Date): string {
  return date ? format(new Date(date), DATE_FORMAT) : '';
}

export function formatAsMonthAndYear(date: Date): string {
  return date ? format(new Date(date), MONTH_YEAR_FORMAT) : '';
}

export function formatTime(dateTime: Date): string {
  return dateTime ? format(new Date(dateTime), TIME_FORMAT) : '';
}

export function currentDayOfMonth(): number {
  return new Date().getDate();
}

export function formatDateTime(date: Date): string {
  return date ? format(new Date(date), DATE_TIME_FORMAT) : '';
}

export function formatAsISODate(date: Date): string {
  return date ? format(new Date(date), ISO_DATE_FORMAT) : '';
}

export function firstDayInEarliestInvoicesYear(): Date {
  return new Date(EARLIEST_INVOICES_YEAR, 0, 1);
}

export function sixMonthsEarlierDate(): Date {
  return sub(now(), { months: 6 });
}

export function parseToISODate(date: string): Date {
  return date ? parse(date, ISO_DATE_FORMAT, new Date()) : null;
}
